<template>
    <div class="page">Redirect permanent</div>
</template>

<script lang="ts" setup>
import { navigateTo, useRoute } from '#app'

const route = useRoute()
const redirectTo = route.meta.redirectTo as string
const newPath = redirectTo.startsWith('http') || redirectTo.startsWith('/') ? redirectTo : `/${redirectTo}`
await navigateTo(newPath, {
    redirectCode: 301,
    external: !!newPath.startsWith('http'),
})
</script>
